import { Brand } from '@/business-components/brand/Brand';
import { ThemeSwitch } from '@/business-components/theme-switch/ThemeSwitch';
import { VersionSelect } from '@/business-components/version-select/VersionSelect';
import { useDocsDataModelStore } from '@/models/docs-data/docsData';
import { NavigationTypeEnum } from '@/shared/constant/navigation/Navigation';
import { OnlineType } from '@/shared/constant/OnlineType';
import clsx from 'clsx';

export type BrandLogoAreaProps = {
  onVersionSelectClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
  onlyShowBrand?: boolean;
  className?: string;
};

export function BrandLogoArea(props: BrandLogoAreaProps) {
  const { className, onlyShowBrand, onVersionSelectClick } = props;

  const type = useDocsDataModelStore((x) => x.navigation.type);
  const onlineType = useDocsDataModelStore((x) => x.docsIdTypeData.onlineType);

  return (
    <div className={clsx('flex items-center', className)}>
      <Brand />
      <div className="flex-1" />

      {!onlyShowBrand && (
        <>
          {onlineType === OnlineType.DocsSite && (
            <VersionSelect
              onClick={onVersionSelectClick}
              className={clsx({
                ['hidden']: type !== NavigationTypeEnum.None,
              })}
            />
          )}
          <ThemeSwitch
            className={clsx({
              ['hidden']: type !== NavigationTypeEnum.None,
            })}
          />
        </>
      )}
    </div>
  );
}
